import { dataCnyCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCnyCircle = /*#__PURE__*/createIcon(dataCnyCircle)
export default IconCnyCircle
